import React from 'react';
import Loading from '../../Loading';


const LoadingPopUp = ({title, subTitle}) => (
    <div className='popup-warning'>
        <div className='popup-loading-inner'>
            <Loading className='loading-image pop-up-loading' />
            <p className='popup-warning-title popup-loading-title'>{title}</p>
            <p className='popup-warning-subtitle'>{subTitle}</p>
        </div>
    </div>
);

export default LoadingPopUp;
